import clsx from 'clsx';
import { Image } from '@_/ui';

export function ThumbnailStrip<TImage extends { imageUrl: string }>({
  images,
  maxItems,
  onClickImage,
  onClickMore,
  renderImageContainer = defaultRenderImageContainer
}: {
  images: TImage[];
  maxItems: number;
  onClickImage?: (index: number, image: TImage) => void;
  onClickMore: (index: number, image: TImage) => void;
  renderImageContainer?: (
    props: { children: React.ReactNode },
    data: { image: TImage; index: number; isOverlay: boolean }
  ) => React.ReactNode;
}) {
  return (
    <div className="flex h-full flex-wrap items-center gap-2">
      {images.slice(0, maxItems).map((image, index) => {
        const isOverlay = index === maxItems - 1 && images.length > maxItems;

        return (
          <button
            key={image.imageUrl}
            className="group relative overflow-hidden rounded-md"
            onClick={
              index === maxItems - 1 && images.length > maxItems
                ? () => onClickMore(index, image)
                : onClickImage
                  ? () => onClickImage(index, image)
                  : undefined
            }
          >
            {renderImageContainer(
              {
                children: (
                  <Image
                    className={clsx(
                      'size-full',
                      !onClickImage && !isOverlay && 'cursor-default',
                      !!onClickImage && !isOverlay && 'group-hover:brightness-80',
                      isOverlay && 'brightness-60 group-hover:brightness-50'
                    )}
                    fit="cover"
                    src={image.imageUrl}
                  />
                )
              },
              { image, index, isOverlay: false }
            )}

            {index === maxItems - 1 && images.length > maxItems && (
              <span className="pointer-events-none absolute inset-0 z-0 flex items-center justify-center text-xl font-semibold text-white">
                {images.length - maxItems}+
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}

function defaultRenderImageContainer({ children }: { children: React.ReactNode }) {
  return <div className="aspect-square h-full">{children}</div>;
}
